var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isSubMenu)?_c('el-menu-item',{ref:"menu",attrs:{"index":_vm.menu.index}},[_vm._v(" "+_vm._s(_vm.menu.text)+"就 ")]):_c('el-submenu',{attrs:{"index":_vm.menu.index}},[_c('template',{slot:"title"},[_vm._v(" "+_vm._s(_vm.menu.text)+" ")]),_vm._t("default",null,{"menus":_vm.menu.children,"level":_vm.level+1})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }